import { useState, useEffect } from 'react';
import { Plus, Edit, Trash2, Eye, Save, ArrowLeft } from 'lucide-react';
import { blogAdminAll, blogCreate, blogUpdate, blogDelete } from '../../api';
import { Link } from 'react-router-dom';

const CATS=['Law Updates','Guides','Labor Law','Business','Tax Law','Property','News'];

export default function BlogManager() {
  const [arts,setArts]   = useState([]);
  const [editing,setEdit]= useState(null);
  const [loading,setLoad]= useState(true);
  const [msg,setMsg]     = useState('');

  useEffect(()=>{ blogAdminAll().then(r=>setArts(r.data.articles||[])).catch(()=>{}).finally(()=>setLoad(false)); },[]);

  const save = async()=>{
    try{
      if(editing.id==='new'){
        const r=await blogCreate(editing);
        setArts(a=>[r.data,...a]);
      } else {
        await blogUpdate(editing.id,editing);
        setArts(a=>a.map(x=>x.id===editing.id?editing:x));
      }
      setMsg('Saved!'); setTimeout(()=>setMsg(''),2000); setEdit(null);
    }catch(e){ alert('Save failed: '+e.message); }
  };

  const del = async id=>{
    if(!window.confirm('Delete this article?')) return;
    try{ await blogDelete(id); setArts(a=>a.filter(x=>x.id!==id)); }catch{}
  };

  const toggle = async art=>{
    const ns=art.status==='published'?'draft':'published';
    try{ await blogUpdate(art.id,{...art,status:ns}); setArts(a=>a.map(x=>x.id===art.id?{...x,status:ns}:x)); }catch{}
  };

  const newArt={id:'new',title:'',excerpt:'',content:'',category:'Law Updates',tags:'',emoji:'📰',author:'LawOC Editorial Team',status:'draft',date:new Date().toISOString().split('T')[0]};

  if(editing){
    return(
      <div>
        <div className="flex items-center gap-3 mb-6 flex-wrap">
          <button onClick={()=>setEdit(null)} className="flex items-center gap-1 text-blue-600 text-sm hover:text-blue-800"><ArrowLeft size={16}/>Blog</button>
          <span className="text-gray-400">/</span>
          <span className="font-bold text-gray-800">{editing.id==='new'?'New Article':'Edit Article'}</span>
          <div className="ml-auto flex items-center gap-2">
            {msg&&<span className="text-green-600 text-sm">{msg}</span>}
            <select value={editing.status} onChange={e=>setEdit(p=>({...p,status:e.target.value}))} className="text-xs border border-gray-200 rounded-lg px-3 py-1.5 outline-none">
              <option value="published">Published</option><option value="draft">Draft</option>
            </select>
            {editing.id!=='new'&&<button onClick={()=>{del(editing.id);setEdit(null);}} className="text-xs text-red-500 border border-red-200 px-3 py-1.5 rounded-lg flex items-center gap-1 hover:bg-red-50"><Trash2 size={11}/>Delete</button>}
            <button onClick={save} className="flex items-center gap-1.5 bg-blue-900 text-white px-4 py-2 rounded-xl text-sm font-semibold hover:bg-blue-800"><Save size={14}/>Save</button>
          </div>
        </div>
        <div className="grid grid-cols-3 gap-6">
          <div className="col-span-2 space-y-4">
            <div><label className="text-xs font-semibold text-gray-500 block mb-1">Article Title *</label><input value={editing.title} onChange={e=>setEdit(p=>({...p,title:e.target.value}))} className="w-full border border-gray-200 rounded-xl px-4 py-3 text-base font-bold outline-none focus:border-blue-500" placeholder="Enter article title..."/></div>
            <div><label className="text-xs font-semibold text-gray-500 block mb-1">Excerpt (summary)</label><textarea value={editing.excerpt} onChange={e=>setEdit(p=>({...p,excerpt:e.target.value}))} rows={2} className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm outline-none focus:border-blue-500 resize-none" placeholder="Brief summary shown in article listings..."/></div>
            <div><label className="text-xs font-semibold text-gray-500 block mb-1">Full Content</label><textarea value={editing.content} onChange={e=>setEdit(p=>({...p,content:e.target.value}))} rows={14} className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm outline-none focus:border-blue-500 resize-none font-mono" placeholder="Write article content here...&#10;&#10;Use blank lines for paragraphs.&#10;Start lines with - for bullet points."/></div>
          </div>
          <div className="space-y-4">
            <div className="bg-white rounded-2xl p-4 border border-gray-100 shadow-sm">
              <h4 className="font-semibold text-gray-700 text-sm mb-3">Settings</h4>
              <div className="space-y-3">
                <div><label className="text-xs font-semibold text-gray-500 block mb-1">Category</label>
                  <select value={editing.category} onChange={e=>setEdit(p=>({...p,category:e.target.value}))} className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none">
                    {CATS.map(c=><option key={c} value={c}>{c}</option>)}
                  </select>
                </div>
                {[['Tags (comma separated)','tags','law, business'],['Author','author','LawOC Editorial Team'],['Cover Emoji','emoji','📰']].map(([l,k,ph])=>(
                  <div key={k}><label className="text-xs font-semibold text-gray-500 block mb-1">{l}</label><input value={editing[k]||''} onChange={e=>setEdit(p=>({...p,[k]:e.target.value}))} placeholder={ph} className={"w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none "+(k==='emoji'?'text-2xl':'')}/></div>
                ))}
                <div><label className="text-xs font-semibold text-gray-500 block mb-1">Publish Date</label><input type="date" value={editing.date||(editing.published_at?.split('T')[0])||''} onChange={e=>setEdit(p=>({...p,date:e.target.value}))} className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none"/></div>
              </div>
            </div>
            <div className="bg-blue-50 rounded-2xl p-4 border border-blue-100">
              <h4 className="font-semibold text-blue-800 text-sm mb-2">Preview</h4>
              <div className="bg-gradient-to-br from-blue-900 to-blue-700 rounded-xl h-20 flex items-center justify-center text-3xl mb-3">{editing.emoji||'📰'}</div>
              <span className="text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full">{editing.category}</span>
              <p className="font-semibold text-gray-800 text-sm mt-2 leading-snug">{editing.title||'Article Title'}</p>
              <div className={"mt-3 inline-flex text-xs font-semibold px-2 py-0.5 rounded-full "+(editing.status==='published'?'bg-green-100 text-green-600':'bg-yellow-100 text-yellow-600')}>{editing.status}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return(
    <>
      <div className="flex items-center justify-between mb-4">
        <div className="grid grid-cols-4 gap-4 flex-1 mr-4">
          {[['Total',arts.length,'text-blue-600'],['Published',arts.filter(a=>a.status==='published').length,'text-green-600'],['Drafts',arts.filter(a=>a.status==='draft').length,'text-yellow-600'],['Categories',[...new Set(arts.map(a=>a.category))].length,'text-purple-600']].map(([l,v,c],i)=>(
            <div key={i} className="bg-white rounded-xl p-3 border border-gray-100 text-center"><div className={"text-xl font-bold "+c}>{v}</div><div className="text-xs text-gray-400">{l}</div></div>
          ))}
        </div>
        <button onClick={()=>setEdit(newArt)} className="flex items-center gap-2 bg-blue-900 text-white px-4 py-2 rounded-xl text-sm font-semibold hover:bg-blue-800 whitespace-nowrap"><Plus size={14}/>New Article</button>
      </div>
      {loading?<div className="text-center py-20 text-gray-400">Loading articles...</div>:(
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
          <div className="px-5 py-3 border-b text-sm font-semibold text-gray-700">All Articles ({arts.length})</div>
          {arts.map(a=>(
            <div key={a.id} className="flex items-center gap-4 px-5 py-4 border-b border-gray-50 hover:bg-gray-50">
              <div className="text-2xl">{a.emoji||'📰'}</div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <h3 className="font-semibold text-gray-800 text-sm truncate">{a.title}</h3>
                  <span className={"text-xs px-2 py-0.5 rounded-full font-semibold shrink-0 "+(a.status==='published'?'bg-green-100 text-green-600':'bg-yellow-100 text-yellow-600')}>{a.status}</span>
                </div>
                <div className="flex items-center gap-2 text-xs text-gray-400">
                  <span className="bg-blue-100 text-blue-600 px-2 py-0.5 rounded-full">{a.category}</span>
                  <span>{a.published_at?new Date(a.published_at).toLocaleDateString():a.created_at?new Date(a.created_at).toLocaleDateString():'—'}</span>
                </div>
              </div>
              <div className="flex gap-2 shrink-0">
                {a.slug&&<Link to={`/blog/${a.slug}`} target="_blank" className="text-xs border border-gray-200 text-gray-500 px-3 py-1.5 rounded-lg flex items-center gap-1 hover:bg-gray-100"><Eye size={11}/>View</Link>}
                <button onClick={()=>setEdit({...a,date:a.published_at?.split('T')[0]||''})} className="text-xs bg-blue-900 text-white px-3 py-1.5 rounded-lg flex items-center gap-1 hover:bg-blue-800"><Edit size={11}/>Edit</button>
                <button onClick={()=>toggle(a)} className={"text-xs border px-3 py-1.5 rounded-lg "+(a.status==='published'?'border-yellow-300 text-yellow-600 hover:bg-yellow-50':'border-green-300 text-green-600 hover:bg-green-50')}>{a.status==='published'?'Unpublish':'Publish'}</button>
                <button onClick={()=>del(a.id)} className="text-red-400 hover:text-red-600"><Trash2 size={15}/></button>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
}
